import { GoToNextStateAftrerFreeSpinAct } from "onearm";
import { AsyncActionsScenario } from "onearm";
import { FreeSpinsPaysAct } from "../../../acts/FreeSpinsPaysAct";
import { FreeSpinsMultiplierAct } from "../../../acts/FreeSpinsMultiplierAct";

import { SubGameState } from "./SubGameState";

export class FreespinWinPresentation extends SubGameState {
    enter({ result, quickStop = false }) {
        this.quickStop = quickStop;
        const spinType = this.data.spinType || "normal";
        this.turboSpin = spinType === "turbo";

        this.resultScenarion = this.makeResultPresentation(result);

        // Акты конструируются жадно, и каждый FreeSpinsPaysAct в конструкторе через сеттер
        // totalWin дёргает hud.setWin. При нескольких pay-шагах каскада последний
        // сконструированный акт оставляет на экране почти-полный тотал раунда до старта
        // анимации счётчика → «вспышка» полного выигрыша. Перезаписываем WIN авторитетным
        // значением последним синхронным вызовом: кумулятив ДО текущего спина
        // (= baseline первого pay-шага), чтобы счётчик стартовал плавно с него.
        this.gameState.hud.setWin(this.gameLogic.getFreeSpinsTotalWin() - (result.totalWin ?? 0));

        this.resultScenarion.start();
        this.scenes = this.gameState.scenes;

        if (this.turboSpin) {
            this.skipAllResults();
        }
    }

    spin() {
        this.data.freeSpinAutoSpin = false;
        this.skipAllResults();
    }

    skipAllResults() {
        if (this.resultScenarion) {
            this.resultScenarion.skipAllIfPossible();
        }

        if (this.resultScenarion ? this.resultScenarion.completed : true) {
            this.resultScenarion = null;
        }
    }

    makeResultPresentation(result) {
        const actions = this.gameState.makeSpinResultPresentation(result, {
            pays: result =>
                new FreeSpinsPaysAct({
                    result,
                    reelsScene: this.gameState.reels,
                    hud: this.gameState.hud,
                    gameLogic: this.gameLogic,
                    scenes: this.gameState.scenes,
                    turboSpin: this.turboSpin,
                }),
            multiplier: result =>
                new FreeSpinsMultiplierAct({
                    result,
                    reelsScene: this.gameState.reels,
                    hud: this.gameState.hud,
                    gameLogic: this.gameLogic,
                }),
        }, { quickStop: this.quickStop });
        actions.push(
            new GoToNextStateAftrerFreeSpinAct({
                gameState: this.gameState,
                gameLogic: this.gameLogic,
            }),
        );

        return new AsyncActionsScenario({ actions });
    }
}
